import React, { useCallback, useMemo } from 'react';
import { useController } from 'react-hook-form';
import InputGroup from '../input-group';
import FieldStatus from '../field-status';
import noop from '../../../utils/noop';
import transfromRequiredRule from '../../helpers/transform-required-rule';
const defaultRules = {};

const InputGroupField = ({
  name,
  control,
  rules: passedRules = defaultRules,
  onChange = noop,
  onBlur = noop,
  processValue = undefined,
  ...otherProps
}) => {
  const rules = useMemo(() => transfromRequiredRule(passedRules), [passedRules]);

  const { field, fieldState } = useController({
    name,
    control,
    rules,
  });

  const handleChange = useCallback(
    (value) => {
      const targetValue = processValue ? processValue(value) : value;

      field.onChange(targetValue);

      if (onChange) {
        onChange(targetValue);
      }
    },
    [field, onChange, processValue]
  );

  const handleBlur = useCallback(
    (...args) => {
      field.onBlur();

      if (onBlur) {
        onBlur(...args);
      }
    },
    [field, onBlur]
  );

  return (
    <React.Fragment>
      <InputGroup
        {...otherProps}
        inputRef={field.ref}
        value={field.value}
        name={field.name}
        invalid={fieldState.invalid}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      {fieldState.error && <FieldStatus appearance="error" text={fieldState.error.message} />}
    </React.Fragment>
  );
};

export default InputGroupField;
